import { Typography } from "@material-ui/core";
import { DateTimeFormatField } from "components/fields/DateFormatField";
import { YesNoField } from "components/fields/YesNoField";
import { FieldType } from "entities/FieldType";
import React from "react";
import { TextField } from "react-admin";

export const CustomFieldField = ({ field }) => {
	const { name, key, value, type } = field;
	const record = { [key]: value };

	switch (type) {
		case FieldType.bool:
			return <YesNoField record={record} source={key} />;
		case FieldType.datetime:
			return <DateTimeFormatField record={record} source={key} />;
		default:
			return <TextField record={record} source={key} />;
	}
};
